import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
  <div class = "row">
  <div class = "col-md-4" >
<span class="created-by">
  <div class="mail">
      <i class="fas fa-envelope fa-2x " status="info"></i>
      <a style="padding-top : 0.3rem; padding-left :0.5rem" target="_blank">info@sdbi.in</a>
  </div>
</span>
</div>  
<div class = "col-md-4" >
<span class="created-by">
  <div class="phone-block" >
      <div class="phone-line-top">
        <span class="material-icons" style="flex-shrink: 0;">phone</span>
        <span class="phone-highlight">9920053700/9372777617</span>
      </div>
      <div class="phone-line-bottom">For assistance with your pre-admission registration, <span class="phone-highlight" style="white-space: nowrap;">call: <span class="phone-blink">+91 93727 77617</span></span></div>
  </div>
</span>
</div>
<div class = "col-md-4" >
<div class="socials " >
<a href="https://www.facebook.com/sdbi.official" target="_blank" class="ion ion-social-facebook"></a>
<a href="https://www.instagram.com/sdbiofficial/" target="_blank" class="ion ion-social-instagram"></a>
<a href="https://www.linkedin.com/company/sdbiofficial" target="_blank" class="ion ion-social-linkedin"></a>
<a href="https://www.youtube.com/channel/UCxyDd_poB_6eMHP_vAPnhwA" target="_blank" class="ion ion-social-youtube"></a>
</div>
</div>
</div>
  `,
})
export class FooterComponent {
}
